module.exports = __webpack_public_path__ + "media/images/icons/time-fa1b0c220e47a700e553b33978c6050d.svg";